var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWallet8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9999 16H81.9999H104V38.0303H81.9999H59.9999H38V60.0606V61.4732V81.9628V82.0911V103.993H16V82.0911V81.9628V61.4732V60.0606V38.0303V16H38H59.9999ZM82.0014 81.9695H60.1296V60.0675H103.988V82.7401C103.988 88.3764 101.753 93.7818 97.7747 97.7684C93.7961 101.755 88.3993 103.996 82.7708 104H82.0014V81.9695Z",
    fill: "#6851FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet8);
export default __webpack_public_path__ + "static/media/icon-wallet-8.ee9d52bfbb0752a8a7065c8def07e235.svg";
export { ForwardRef as ReactComponent };